<template>
  <v-dialog
    v-model="show"
    max-width="450px"
    persistent
  >
    <v-card>
      <v-card-title class="pa-3">
        Tag
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-3">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="currentTag"
              label="Tags"
              hide-details=""
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-3">
        <v-spacer />
        <v-btn
          color="success"
          outlined
          @click="updateTag()"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	name: "EditTag",
	props: {
		showEditTag: { type: Boolean, default: false },
		tagInfo: { type: Object, default: () => {} }
	},
	data() {
		return {
			currentTag: ""
		};
	},
	computed: {
		show() {
			return this.showEditTag || false;
		}
	},
	watch: {
		show(s) {
			if (s) {
				console.log(this.tagInfo, "TAGINFO");
        if (this.tagInfo){
          this.currentTag = JSON.parse(JSON.stringify(this.tagInfo.tags ? this.tagInfo.tags : "" ));
        }
			}
		}
	},
	methods: {
		close(){
			this.$emit("update:showEditTag", false);
		},
		updateTag() {
      this.$emit("updateTag", {refID: this.tagInfo.refID || this.tagInfo.id, tags: this.currentTag});
			this.close();
		}
	}
};
</script>